import React from 'react';
import { Button, Icon } from '@medely/ui-kit';
import { useFavoriteButtonLogic } from './useFavoriteButtonLogic';
import { FavoriteButtonProps } from './interface';
import { useNoOutlineWrapper } from './useNoOutlineWrapper';

const isWeb = typeof window !== 'undefined' && window.document;

export const AssignmentFavoriteButton = ({
  assignment,
  iconSize = 'sm',
  testId = 'assignment-favorite-button',
  isIconOnly = false,
  htmlColor,
  activeHtmlColor,
  bgColor: _bgColor,
}: FavoriteButtonProps) => {
  const { isFavorited, toggleFavorite } = useFavoriteButtonLogic({
    assignmentId: assignment.id,
  });

  const { wrapWithNoOutline } = useNoOutlineWrapper(testId, !!isWeb);

  const isBookedInProgressCompleted = ['booked', 'completed', 'in_progress'].includes(
    assignment.status,
  );

  if (isBookedInProgressCompleted) {
    return null;
  }

  const getIconSize = () => {
    switch (iconSize) {
      case 'md':
        return '24px';
      case 'sm':
      default:
        return '16px';
    }
  };

  const getColor = (isFavorited: boolean) => {
    if (htmlColor || activeHtmlColor) {
      return isFavorited ? activeHtmlColor || 'state.teal.primary' : htmlColor || 'text.primary';
    }
    return isFavorited ? 'state.teal.primary' : 'text.primary';
  };

  const handleClick = () => {
    toggleFavorite();
  };

  const buttonComponent = (
    <Button
      variant="text"
      onClick={handleClick}
      testId={testId}
      {...(isIconOnly && { isIconOnly: true })}
      startIcon={
        <Icon
          name={isFavorited ? 'solid-heart' : 'heart'}
          iconSize={getIconSize()}
          data-testid={`${testId}-${isFavorited ? 'heart-solid' : 'heart'}`}
          color={getColor(isFavorited)}
          variant="custom"
        />
      }
    />
  );

  return wrapWithNoOutline(buttonComponent);
};

export default AssignmentFavoriteButton;
